<template>
  <v-container fluid>
    <v-form class="pt-5">
      <v-row>
        <v-col cols="12">
          <base-material-card
            color="primary"
            icon="mdi-map-marker-question"
            inline
            class="px-5 py-3"
            :title="`Editar Simbologia do Layer: ${relatorio.nome}`"
          >
            <v-row align="center" no-gutters class="ml-0">
              <v-col id="selecao-simbologia" cols="12">
                <v-radio-group v-model="tipoSimbologia" mandatory row>
                  <v-radio label="Simples" value="simples" />
                  <v-radio label="Categorizada" value="categorizada" :disabled="!simbologiaCategorizadaHabilitada" />
                  <v-radio label="Graduada" value="graduada" :disabled="!simbologiaGraduadaHabilitada" />
                  <v-radio label="Mapa de Calor" value="mapa_calor" :disabled="!simbologiaMapaCalorHabilitada" />
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row align="center" no-gutters class="ml-0">
              <v-col cols="12">
                <v-alert dense outlined type="info" color="blue" class="mb-0 px-1 py-1">
                  <div v-if="tipoSimbologia == 'simples'">
                    Escolha simbologia simples caso queira que as feições a serem plotadas no mapa tenham a mesma cor e simbologia
                    gráfica.
                  </div>
                  <div v-else-if="tipoSimbologia == 'categorizada'">
                    Escolha simbologia categorizada caso queira alterar as cores e símbolos de acordo com a classificação dos
                    dados de um determinado
                    <span class="underline">campo não numérico</span>
                    , como por exemplo escolher cores diferentes para polígonos que representam regiões de um país.
                  </div>
                  <div v-else-if="tipoSimbologia == 'graduada'">
                    Escolha simbologia graduada caso queira escolher um
                    <span class="underline">campo numérico</span>
                    para formar intervalos de dados, podendo pintar cada intervalo com cores distintas.
                  </div>
                  <div v-else>
                    Escolha simbologia mapa de calor caso queira escolher um
                    <span class="underline">campo numérico</span>
                    para identificar
                    <span class="underline">áreas quentes</span>
                    em seus dados, como por exemplo uma região do país com maior densidade populacional.
                  </div>
                </v-alert>
              </v-col>
            </v-row>
            <br />
          </base-material-card>
        </v-col>
      </v-row>
      <v-row id="row-parametros">
        <v-col md="6" cols="12">
          <base-material-card color="primary" icon="mdi-playlist-edit" inline class="px-5 py-3" style="min-height: 500px">
            <template v-slot:after-heading>
              <div>
                Parâmetros Simbologia
                <span v-if="tipoSimbologia == 'simples'">Simples</span>
                <span v-else-if="tipoSimbologia == 'categorizada'">Categorizada</span>
                <span v-else-if="tipoSimbologia == 'graduada'">Graduada</span>
                <span v-else>Mapa de Calor</span>
              </div>
            </template>
            <v-row v-if="tipoDadoGeografico">
              <v-col id="form-parametros" cols="12">
                <form-parametros-simbologia-simples
                  v-if="tipoSimbologia === 'simples'"
                  :tipoDadoGeografico="tipoDadoGeografico"
                />
                <form-parametros-simbologia-categorizada
                  v-else-if="tipoSimbologia === 'categorizada'"
                  :relatorio="relatorio"
                  :campos="dadosRelatorio.cabecalho"
                  :tiposDadosCampos="dadosRelatorio.tiposDados"
                  :tipoDadoGeografico="tipoDadoGeografico"
                />
                <form-parametros-simbologia-graduada
                  v-else-if="tipoSimbologia === 'graduada'"
                  :relatorio="relatorio"
                  :campos="dadosRelatorio.cabecalho"
                  :tiposDadosCampos="dadosRelatorio.tiposDados"
                  :tipoDadoGeografico="tipoDadoGeografico"
                />
                <form-parametros-simbologia-mapa-calor
                  v-else
                  :relatorio="relatorio"
                  :campos="dadosRelatorio.cabecalho"
                  :tiposDadosCampos="dadosRelatorio.tiposDados"
                />
              </v-col>
            </v-row>
          </base-material-card>
        </v-col>
        <v-col md="6" cols="12">
          <base-material-card
            color="primary"
            icon="mdi-map-outline"
            inline
            class="px-5 py-3"
            style="min-height: 500px"
            title="Visualização do mapa"
          >
            <v-row>
              <v-col cols="12">
                <v-alert dense outlined type="info" color="blue" class="mb-3 px-1 py-1">
                  Esse mapa exibe no máximo 500 registros.
                </v-alert>
                <div id="mapa-simbologia">
                  <preview-mapa-simbologia-simples
                    v-if="tipoSimbologia === 'simples'"
                    :relatorio="relatorio"
                    :linhasRelatorio="linhasRelatorioAssoc"
                  />
                  <preview-mapa-simbologia-categorizada
                    v-else-if="tipoSimbologia === 'categorizada'"
                    :relatorio="relatorio"
                    :linhasRelatorio="linhasRelatorioAssoc"
                  />
                  <preview-mapa-simbologia-graduada
                    v-else-if="tipoSimbologia === 'graduada'"
                    :relatorio="relatorio"
                    :linhasRelatorio="linhasRelatorioAssoc"
                  />
                  <preview-mapa-simbologia-mapa-calor v-else :relatorio="relatorio" :linhasRelatorio="linhasRelatorioAssoc" />
                </div>
              </v-col>
            </v-row>
          </base-material-card>
        </v-col>
      </v-row>
      <v-row id="row-relatorios-pre-view">
        <v-col cols="12">
          <relatorios-pre-view :relatorioId="relatorio.id" :relatorioNome="relatorio.nome" />
        </v-col>
      </v-row>
      <v-row id="row-btn-save">
        <v-col cols="12">
          <v-btn
            id="btn-save"
            color="primary"
            min-width="100"
            style="float: right"
            class="mr-0 mt-n5"
            :disabled="btnSaveDisabled"
            :loading="loading"
            @click="salvar()"
          >
            Salvar
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
  import RelatoriosService from '@/services/RelatoriosService';
  import routes from '@/store/modules/routes';

  export default {
    components: {
      FormParametrosSimbologiaSimples: () =>
        import('@/components/layers-personalizados/formularios/FormParametrosSimbologiaSimples.vue'),
      FormParametrosSimbologiaCategorizada: () =>
        import('@/components/layers-personalizados/formularios/FormParametrosSimbologiaCategorizada.vue'),
      FormParametrosSimbologiaGraduada: () =>
        import('@/components/layers-personalizados/formularios/FormParametrosSimbologiaGraduada.vue'),
      FormParametrosSimbologiaMapaCalor: () =>
        import('@/components/layers-personalizados/formularios/FormParametrosSimbologiaMapaCalor.vue'),
      PreviewMapaSimbologiaSimples: () =>
        import('@/components/layers-personalizados/previews-mapas/PreviewMapaSimbologiaSimples.vue'),
      PreviewMapaSimbologiaCategorizada: () =>
        import('@/components/layers-personalizados/previews-mapas/PreviewMapaSimbologiaCategorizada.vue'),
      PreviewMapaSimbologiaGraduada: () =>
        import('@/components/layers-personalizados/previews-mapas/PreviewMapaSimbologiaGraduada.vue'),
      PreviewMapaSimbologiaMapaCalor: () =>
        import('@/components/layers-personalizados/previews-mapas/PreviewMapaSimbologiaMapaCalor.vue'),
      RelatoriosPreView: () => import('@/components/relatorios/RelatoriosPreView')
    },

    data: () => ({
      relatorio: {},
      tipoSimbologia: 'simples',
      tipoDadoGeografico: '',
      dadosRelatorio: {
        cabecalho: [],
        dados: []
      },
      loading: false
    }),

    computed: {
      linhasRelatorioAssoc() {
        let cabecalho = this.dadosRelatorio.cabecalho;
        let linhas = this.dadosRelatorio.dados.map((linha) => {
          let novaLinha = {};
          linha.forEach((dado, indice) => (novaLinha[cabecalho[indice]] = dado));
          return novaLinha;
        });
        return linhas;
      },

      btnSaveDisabled() {
        switch (this.tipoSimbologia) {
          case 'simples':
            return !this.simbologiaConfig.simples.corFeicoes;
          case 'categorizada':
            return !(
              this.simbologiaConfig.categorizada.campoParaClassificacao &&
              this.simbologiaConfig.categorizada.iconeCorOutrasFeicoes.cor &&
              Object.keys(this.simbologiaConfig.categorizada.iconesCoresFeicoes).length
            );
          case 'graduada':
            return !(
              this.simbologiaConfig.graduada.campoParaClassificacao &&
              this.simbologiaConfig.graduada.iconeCorOutrasFeicoes.cor &&
              this.simbologiaConfig.graduada.iconesCoresFeicoes.length &&
              this.simbologiaConfig.graduada.valorMinimo < this.simbologiaConfig.graduada.valorMaximo
            );
          default:
            return !(
              this.simbologiaConfig.mapa_calor.campoParaClassificacao &&
              this.simbologiaConfig.mapa_calor.raioPontos &&
              this.simbologiaConfig.mapa_calor.desfoquePontos
            );
        }
      },

      simbologiaConfig() {
        return this.$store.getters.getSimbologiaConfig;
      },

      simbologiaCategorizadaHabilitada() {
        return this.linhasRelatorioAssoc.length > 1;
      },

      simbologiaGraduadaHabilitada() {
        return this.linhasRelatorioAssoc.length > 1;
      },

      simbologiaMapaCalorHabilitada() {
        return this.tipoDadoGeografico === 'PONTO' && this.linhasRelatorioAssoc.length > 1;
      }
    },

    mounted() {
      this.getRelatorio(this.$route.params.id);
    },

    methods: {
      getRelatorio(id) {
        RelatoriosService.getRelatorio(id)
          .then((response) => {
            this.relatorio = response.data.data;
            this.tipoDadoGeografico = this.relatorio.tipo_dado_geografico;
            this.tipoSimbologia = this.relatorio.tipo_simbologia.toLowerCase();
            this.getDadosRelatorio(id);
          })
          .catch(() =>
            this.$toast.error('Erro ao recuperar o layer.', '', {
              position: 'topRight'
            })
          );
      },

      getDadosRelatorio(id) {
        RelatoriosService.preVisualizar(id, 1)
          .then((response) => {
            this.dadosRelatorio = {
              cabecalho: response.data.cabecalho,
              dados: response.data.dados,
              tiposDados: JSON.parse(response.data.arrCamposTiposDados)
            };
            this.setSimbologiaConfig();
          })
          .catch(() =>
            this.$toast.error('Erro ao baixar os dados do layer.', '', {
              position: 'topRight'
            })
          );
      },

      setSimbologiaConfig() {
        this.$store.dispatch('resetaSimbologiaConfig');

        const simbologiaConfig = JSON.parse(this.relatorio.simbologia_config);

        switch (this.tipoSimbologia) {
          case 'simples':
            this.$store.dispatch('setSimbologiaConfigSimplesCorFeicoes', simbologiaConfig.corFeicoes);
            this.$store.dispatch('setSimbologiaConfigSimplesIconeFeicoes', simbologiaConfig.iconeFeicoes);
            break;
          case 'categorizada':
            this.$store.dispatch(
              'setSimbologiaConfigCategorizadaCampoParaClassificacao',
              simbologiaConfig.campoParaClassificacao
            );
            this.$store.dispatch('setSimbologiaConfigCategorizadaIconeCorOutrasFeicoes', simbologiaConfig.iconeCorOutrasFeicoes);
            this.$store.dispatch('setSimbologiaConfigCategorizadaIconesCoresFeicoes', simbologiaConfig.iconesCoresFeicoes);
            break;
          case 'graduada':
            this.$store.dispatch('setSimbologiaConfigGraduadaCampoParaClassificacao', simbologiaConfig.campoParaClassificacao);
            this.$store.dispatch('setSimbologiaConfigGraduadaIconeCorOutrasFeicoes', simbologiaConfig.iconeCorOutrasFeicoes);
            this.$store.dispatch('setSimbologiaConfigGraduadaIconesCoresFeicoes', simbologiaConfig.iconesCoresFeicoes);
            this.$store.dispatch('setSimbologiaConfigGraduadaValorMinimo', simbologiaConfig.valorMinimo);
            this.$store.dispatch('setSimbologiaConfigGraduadaValorMaximo', simbologiaConfig.valorMaximo);
            break;
          default:
            this.$store.dispatch('setSimbologiaConfigMapaCalorCampoParaClassificacao', simbologiaConfig.campoParaClassificacao);
            this.$store.dispatch('setSimbologiaConfigMapaCalorRaioPontos', simbologiaConfig.raioPontos);
            this.$store.dispatch('setSimbologiaConfigMapaCalorDesfoquePontos', simbologiaConfig.desfoquePontos);
        }
      },

      salvar() {
        this.loading = true;

        const data = {
          tipo_simbologia: this.tipoSimbologia,
          simbologia_config: this.simbologiaConfig[this.tipoSimbologia]
        };

        RelatoriosService.saveSimbologiaConfig(this.$route.params.id, data)
          .then(() => {
            this.$toast.success('Simbologia do layer configurado com sucesso.', '', { position: 'topRight' });
            this.$router.replace({
              name: routes.state.appRoutes['LAYERS_PERSONALIZADOS_HISTORICO']
            });
          })
          .catch(() => {
            this.$toast.error('Erro ao salvar a configuração da simbologia do layer.', '', { position: 'topRight' });
          })
          .finally(() => (this.loading = false));
      }
    }
  };
</script>

<style scoped>
  .underline {
    text-decoration: underline;
  }
</style>
